module.exports = __webpack_public_path__ + "static/shoutcart_about2-3b565c1cc3e62af1691590f5e1370b65.png";